import {graphql} from 'react-relay'

import {getOwnTestsLocator} from '../../../../../../../packages/Tests/TestsPreviewPanel/TestsPreviewPanel.utils'

export const jobTestsTreeCountsQuery = graphql`
  query JobTestsTreeCountsQuery($locator: String!) {
    testOccurrences(locator: $locator) {
      ...OverviewTabFragment
    }
  }
`

export const getCountsVariables = (buildLocator: string) => ({
  locator: `${getOwnTestsLocator(buildLocator)},count:-1`,
})
